/**
 * The realtime socket does not replay what it missed while it was down, so when it comes
 * back the form asks for the quote again, after a random delay: after an outage every open
 * form reconnects within seconds and a full quote can be heavy, so they do not ask together. A first connection that never failed does not
 * need it (the quote was just loaded); one that only succeeds after failed attempts does.
 */
export const createReconnectRefresh = (refresh: () => void, getDelayMs: () => number = () => 0) => {
    let disconnected = false;
    let timer: ReturnType<typeof setTimeout> | undefined;

    return {
        onClose: () => {
            disconnected = true;
            // Closed again before it was time to ask: the next reconnection will.
            if (timer) clearTimeout(timer);
            timer = undefined;
        },
        onOpen: () => {
            if (!disconnected) return;
            disconnected = false;
            const run = () => {
                timer = undefined;
                try {
                    refresh();
                } catch (error) {
                    // A failing refresh must never break the socket handlers.
                    console.error('Refresh after reconnecting failed:', error);
                }
            };
            const delay = getDelayMs();
            if (delay > 0) timer = setTimeout(run, delay);
            else run();
        },
    };
};
